import React, { useState } from 'react';
import './autocomplete.css'; // Para los estilos opcionales
import { setCalle } from '../../redux/form/formSlice';
import { useDispatch } from 'react-redux';

const Autocomplete = ({ data, field, form }) => {
    const [inputValue, setInputValue] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const dispatch = useDispatch();

    const handleInputChange = (e) => {
        const value = e.target.value;
        form.setFieldValue(field.name,value);
        
        setInputValue(value);

        setIsDropdownOpen(true);

        if (value.length >= 3) {
            const newFilteredData = data.filter(item =>
                item.nombre.toLowerCase().includes(value.toLowerCase())
            );
            setFilteredData(newFilteredData);
            setIsDropdownOpen(true);
        } else {
            setFilteredData([]);
            //setIsDropdownOpen(false);
        }
    };

    const handleItemClick = (item) => {
        setInputValue(item.nombre);        
        setFilteredData([]);
        setIsDropdownOpen(false);
        //dispatch(setCalle(item.nombre));
        dispatch(setCalle(item.id))
    };

    const handleClickOutside = (e) => {
        if (!e.target.closest('.autocomplete-container')) {
            setIsDropdownOpen(false);
        }
    };

    React.useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    return (
        <div className="autocomplete-container">      
            <input
                {...field}
                type="text"
                value={inputValue}
                onChange={handleInputChange}
                placeholder="Buscá la calle..."
            />
            {isDropdownOpen && (
                <div className="autocomplete-dropdown">
                  {inputValue.length < 3 ? (
                        <div className="autocomplete-item">Escribí al menos 3 caracteres</div>
                    ) : filteredData.length > 0 ? (
                        filteredData.map((item, index) => (
                            <div
                                key={index}
                                className="autocomplete-item"
                                onClick={() => handleItemClick(item)}
                            >
                                {item.nombre}
                            </div>
                        ))
                    ) : (
                        <div className="autocomplete-item">No hay resultados</div>
                    )}
                </div>
            )}
        </div>
    );
};

export default Autocomplete;
